import React from 'react'
import styled, { useTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { COLORS } from 'COLORS'

import { ToggleButton } from '@junglescout/edna'

const Toggle = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 940px) {
    padding-left: 0;
  }
`

const FrequencyLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: ${props => (props.isActive ? COLORS.grey900 : COLORS.grey300)};
`

const UpsellToggle = props => {
  const { disabled, billingFrequency, toggleAction } = props
  const isChecked = billingFrequency === 'yearly'

  const { colors } = useTheme()

  return (
    <Toggle>
      <FrequencyLabel isActive={!isChecked}>Pay Monthly</FrequencyLabel>
      <ToggleButton
        id="toggle_upsell_type"
        checked={isChecked}
        disabled={disabled}
        handleToggleClick={toggleAction}
        checkedColor={colors.primary}
        uncheckedColor={colors.primary}
        margin="0 10px"
      />
      <FrequencyLabel isActive={isChecked}>Pay Yearly</FrequencyLabel>
    </Toggle>
  )
}

UpsellToggle.propTypes = {
  disabled: PropTypes.bool,
  billingFrequency: PropTypes.string,
  toggleAction: PropTypes.func.isRequired
}

export { UpsellToggle }
